  // core version + navigation, pagination modules:
  import Swiper, { Navigation, Pagination, FreeMode } from 'swiper';

/**
 * imports and determines slider parameters.
 *
 * @param object parameters of library https://swiperjs.com/swiper-api
 *
 * @author Andres Briñez abrinez
 */

export const swiperCollectionSection = () => {
  new Swiper(".carousel-collection-slider", {
    modules: [ Navigation, Pagination, FreeMode ],
    slidesPerView: "auto",
    spaceBetween: 17,
    navigation: {
      nextEl: ".button-next",
      prevEl: ".button-prev",
    },
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 580px
      580: {
          slidesPerView: "auto",
          spaceBetweenSlides: 20
      },
      // when window width is >= 999px
      950: {
          slidesPerView: 2,
          spaceBetweenSlides: 20,
      },
      1050: {
        slidesPerView: 3,
        spaceBetweenSlides: 20
      },
    },
    
  });
};